/**
 * The staff "Create New Project" flow, shared by the dashboard's floating + (DashboardPage.vue)
 * and the header + (Navigation.vue) so the two buttons cannot drift apart again. The header
 * copy used to skip the role step, so a creator who used it was never assigned to the roles
 * flagged "Automatically assign project creator to this role", and with no location selected
 * it sent `locations: [null]`.
 *
 * The role write sets one field path per flagged role (`roles.<id>`), the same write the Vue 3
 * app makes, so the other roles keep the default members the server gave them. The dashboard
 * copy used to replace the whole `roles` map.
 */
import { doc, updateDoc } from 'firebase/firestore'

/**
 * @param {object} $root the root Vue instance
 * @return {Promise<string>} the new project's id
 */
export async function createStaffProject ($root) {
  const location = $root.locationView
  const resp = await $root.callFunction('createProject', {
    enterprise: $root.enterpriseID,
    location,
    locations: [location || $root.enterprise.defaultLocation],
  })
  const projectID = resp.data

  const uid = $root.currentUser && $root.currentUser.uid
  const creatorRoles = (($root.configPublic && $root.configPublic.projectRoles) || []).filter(role => role.assignProjectCreator)
  if (uid && creatorRoles.length > 0) {
    const update = { lastUpdatedBy: uid, dateModified: Date.now() }
    creatorRoles.forEach(role => { update[`roles.${role.id}`] = [uid] })
    await updateDoc(doc($root.db, 'enterprises', $root.enterpriseID, 'projects', projectID), update)
  }
  return projectID
}
